import {httpDelete, httpGet, httpPatch, httpPost, httpPut} from '../../../../service/http.service';
import {IPresentationFolder} from './types';

const BASE_FOLDERS_URL = 'editor/presentation-folders';
const BASE_PRESENTATIONS_URL = 'editor/presentations';

export const fetchPresentationFolders = (): Promise<IPresentationFolder[]> => {
    return httpGet(BASE_FOLDERS_URL);
};

export const createPresentationFolder = (name: string): Promise<IPresentationFolder> => {
    return httpPost(BASE_FOLDERS_URL, {name});
};

export const renamePresentationFolder = (folderId: string, name: string): Promise<IPresentationFolder> => {
    return httpPut(`${BASE_FOLDERS_URL}/${folderId}`, {name});
};

export const deletePresentationFolder = (folderId: string): Promise<void> => {
    return httpDelete(`${BASE_FOLDERS_URL}/${folderId}`, {});
};

export const movePresentationsToFolder = (presentationIds: string[], folderId: string | null): Promise<boolean> => {
    return httpPatch(`${BASE_PRESENTATIONS_URL}/move`, {presentationIds, folderId});
};
